import React from 'react'
import styled from 'styled-components'
import { Config } from '../../../../../../config'

export const CloseIcon = ({ handleClick }: { handleClick: () => void }) => {
  return (
    <Container className="p-2" onClick={handleClick}>
      <SVGWrapper>
        <svg viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.37 4.5l3.45-3.46a.61.61 0 0 0-.87-.86L4.5 3.63 1.04.18a.61.61 0 0 0-.86.86L3.63 4.5.18 7.95a.61.61 0 0 0 .86.87L4.5 5.37l3.45 3.45a.61.61 0 0 0 .87-.87L5.37 4.5z"></path>
        </svg>
      </SVGWrapper>
    </Container>
  )
}

const { breakpoints, palette } = Config

const Container = styled.div`
  width: 4.2rem;
  min-width: 4.2rem;
  height: 4.2rem;
  min-height: 4.2rem;
  border: 0.1rem solid;
  border-radius: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 12px;
  right: 12px;
  background: ${palette.secondary};
  border: none;
  color: ${palette.primary};
  position: absolute;
  transform: translateX(0);
  outline: none;

  &:hover {
    background: #f5f5f5;
    border-color: ${palette.disabled};
  }

  @media (min-width: ${breakpoints.md.min}) {
    width: 3.7rem;
    min-width: 3.7rem;
    height: 3.7rem;
    min-height: 3.7rem;
  }

  cursor: pointer;
`

const SVGWrapper = styled.svg`
  position: relative;
  top: auto;
  right: auto;
  max-width: 100%;
  height: 1.5rem;
  height: 1.2rem;
`
